var $b353f6056f620327$exports = {};
$b353f6056f620327$exports = {
    "collectionLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`
};


export {$b353f6056f620327$exports as default};
//# sourceMappingURL=he-IL.module.js.map
